import { createTrignometryOperator } from "./_internal";
const $sin = createTrignometryOperator(Math.sin);
export {
  $sin
};
